import { render, staticRenderFns } from "./CollegeSubscriptionUserList.vue?vue&type=template&id=3ff80c70"
import script from "./CollegeSubscriptionUserList.vue?vue&type=script&lang=js"
export * from "./CollegeSubscriptionUserList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports